<template>
    <div class="profit-setting">
        <div class="title-box">
            <div class="back" @click="goBack">返回</div>
            <div class="line"></div>
            <div class="title">绑定银行卡</div>
        </div>
        <veui-form
            ref="profitForm"
            :data="formData"
            :validators="validators"
            :class="{'veui-field-show': inputDisabled}"
        >
            <div class="profit-setting-content">
                <div class="profit-setting-content-tip">
                    根据百信银行反洗钱项目规定，平台需要收集您的相关个人信息，还请如实<!--
                    -->正确填写，后续我们将打款到以下您预留的银行卡账户上，律临将确保您的信息安全，生效后不<!--
                    -->允许随意修改，请谨慎填写！另外，目前平台暂不支持财务信息变更，若有账号变更需求，请邮件至<!--
                    --><a class="tip-email" href="mailto:lvlin_help@baidu.com">lvlin_help@baidu.com</a><!--
                    -->申请线下变更。
                </div>
                <div class="profit-setting-form-title">绑卡信息</div>
                <div class="profit-setting-form-show">
                    <veui-field
                        name="username"
                        label="收款人姓名"
                        class="veui-field-required profit-setting-username"
                        :rules="[{name: 'required', value: true, message: '请输入收款人姓名'}]"
                    >
                        <veui-input
                            v-if="!inputDisabled"
                            v-model="formData.username"
                            placeholder="请输入收款人姓名"
                            :disabled="inputDisabled"
                        >
                        </veui-input>
                        <div v-else>
                            {{ formData.username }}
                        </div>
                    </veui-field>
                    <veui-fieldset
                        class="desc-warp veui-field-required"
                        label="身份证"
                        required
                    >
                        <veui-field
                            name="id_card_head_image_url"
                            field="id_card_head_image_url"
                            :rules="[{name: 'required', value: true, message: '请上传人像面'}]"
                        >
                            <veui-uploader
                                v-if="!inputDisabled"
                                class="portrait"
                                :max-count="1"
                                accept="image/*"
                                :extensions="['jpg','png','jpeg']"
                                max-size="1024kb"
                                :value="!formData.id_card_head_image_url ?
                                    null : [{'src': formData.id_card_head_image_url}]"
                                :convert-response="(data) => convertResponse(data, 'id_card_head_image')"
                                type="image"
                                :action="getCardUrl('action=band_bank_card&id_card_type=11')"
                                ui="s"
                                @change="res => uploaderChange(res, 'id_card_head_image_url')"
                            >
                            </veui-uploader>
                            <div v-else class="img-wrapper">
                                <img
                                    class="viewimg"
                                    :src="formData.id_card_head_image_url"
                                    alt=""
                                >
                            </div>
                        </veui-field>
                        <veui-field
                            name="id_card_national_image_url"
                            class="ml12 emblem"
                            field="id_card_national_image_url"
                            :rules="[{name: 'required', value: true, message: '请上传国徽面'}]"
                        >
                            <veui-uploader
                                v-if="!inputDisabled"
                                name="file"
                                max-size="1024kb"
                                accept="image/*"
                                :extensions="['jpg','png','jpeg']"
                                :value="!formData.id_card_national_image_url ?
                                    null : [{'src': formData.id_card_national_image_url}]"
                                :max-count="1"
                                :convert-response="(data) => convertResponse(data, 'id_card_national_image')"
                                type="image"
                                :action="getCardUrl('action=band_bank_card&id_card_type=12')"
                                ui="s"
                                @change="res => uploaderChange(res, 'id_card_national_image_url')"
                            >
                            </veui-uploader>
                            <div v-else class="img-wrapper">
                                <img
                                    class="viewimg"
                                    :src="formData.id_card_national_image_url"
                                    alt=""
                                >
                            </div>
                            <div v-if="!inputDisabled" class="decs">
                                <p>1、请参照示例拍照上传身份证照片，确保证件信息清晰可见</p>
                                <p>2、要求照片1M以内，支持jpg/jpeg/png格式</p>
                            </div>
                        </veui-field>
                    </veui-fieldset>
                </div>
                <veui-field
                    name="id_card_num"
                    label="身份证号"
                    class="desc-warp veui-field-required"
                    :rules="rules.idCardNum"
                >
                    <veui-input
                        v-if="!inputDisabled"
                        v-model="formData.id_card_num"
                        placeholder="请输入身份证号"
                        :disabled="inputDisabled"
                    >
                    </veui-input>
                    <div v-else>
                        {{ formData.id_card_num }}
                    </div>
                </veui-field>
                <veui-field
                    name="card_num"
                    label="银行账号"
                    class="desc-warp veui-field-required"
                    :rules="rules.accountCode"
                >
                    <veui-input
                        v-if="!inputDisabled"
                        v-model="formData.card_num"
                        placeholder="请输入银行账号"
                        :disabled="inputDisabled"
                    >
                    </veui-input>
                    <div v-else style="width: 100%;line-height: 32px;">
                        {{ formData.card_num }}
                    </div>
                </veui-field>
                <div class="desc-warp-content">
                    律临平台会在每月20日自动给您结算上个自然月的收益金额，届时会对此帐号进行税后打款操作，请您务必<!--
                    -->正确填写与律师本人姓名对应的银行活期账户卡卡号（非银行存折号或信用卡卡号），并确保银行预留电话填<!--
                    -->写正确，两项信息填写错误将不能按时获得您的收益。
                </div>
                <veui-field
                    name="phone_num"
                    label="银行预留手机号"
                    class="veui-field-required"
                    :rules="rules.mobileNumber"
                >
                    <veui-input
                        v-if="!inputDisabled"
                        v-model="formData.phone_num"
                        placeholder="请输入银行预留手机号"
                        :disabled="inputDisabled"
                    >
                    </veui-input>
                    <div v-else>
                        {{ formData.phone_num }}
                    </div>
                </veui-field>
                <veui-field
                    name="id_card_expire_time"
                    label="身份证到期日"
                    class="veui-field-required"
                    :rules="[{name: 'required', value: true, message: '请选择身份证到期日'}]"
                >
                    <veui-date-picker
                        v-if="!inputDisabled"
                        v-model="formData.id_card_expire_time"
                        format="yyyy/MM/dd"
                        placeholder="请选择身份证到期日"
                    />
                    <div v-else>
                        {{ formData.id_card_expire_time }}
                    </div>
                </veui-field>
                <veui-field
                    name="sex"
                    label="性别"
                    class="veui-field-required s"
                    :rules="[{name: 'required', value: true, message: '请选择性别'}]"
                >
                    <div v-if="!inputDisabled">
                        <veui-radio
                            v-for="({value, label}) in sexList"
                            :key="value"
                            v-model="formData.sex"
                            class="profit-setting-radio"
                            style="margin-right: 24px;"
                            :value="value"
                            :disabled="inputDisabled"
                        >
                            {{ label }}
                        </veui-radio>
                    </div>
                    <div v-else>
                        {{ formData.sex }}
                    </div>
                </veui-field>
                <veui-field
                    name="country"
                    label="国籍"
                    class="veui-field-required s"
                >
                    <div>中国</div>
                </veui-field>
                <veui-field
                    name="profession"
                    label="职业"
                    class="veui-field-required s"
                >
                    <div>{{ formData.professionShow }}</div>
                </veui-field>
                <veui-field
                    name="address"
                    label="现居住地址"
                    class="veui-field-required profit-setting-textarea"
                    :rules="[{
                        name: 'required',
                        value: true,
                        message: '请输入现居住地址',
                    }]"
                >
                    <veui-textarea
                        v-if="!inputDisabled"
                        v-model="formData.address"
                        :disabled="inputDisabled"
                    />
                    <div v-else>
                        {{ formData.address }}
                    </div>
                </veui-field>
            </div>
            <div v-if="!inputDisabled" class="profit-setting-footer">
                <veui-field
                    v-if="!inputDisabled"
                    class="profit-setting-rule"
                    name="isAgree"
                    label=""
                    :rules="[{
                        name: 'required',
                        value: true,
                        message: '请勾选声明文件',
                    }]"
                >
                    <veui-checkbox v-model="formData.isAgree" :false-value="null">我已阅读并同意 </veui-checkbox>
                    <a
                        class="file-name"
                        href="https://law-smartapp.cdn.bcebos.com/Individual_tax_residency_self__certificatio.pdf"
                        target="_blank"
                    > 《个人税收居民身份声明文件》</a>
                </veui-field>
                <veui-button
                    v-if="!inputDisabled"
                    ui="primary"
                    class="submit"
                    :disabled="inputDisabled"
                    :loading="buttonLoading"
                    @click="save"
                >提交</veui-button>
            </div>
        </veui-form>
        <veui-dialog
            v-if="confirmModal"
            :open.sync="confirmModal"
            title="确认提交"
            overlay-class="profit-setting-confirm-modal"
            :before-close="handleModal"
        >
            <veui-grid-container :margin="0" :padding="0">
                <veui-grid-row class="confirm-modal-tip">
                    <veui-grid-column :span="24">
                        信息一旦提交不可更改，请再次确认以下信息：
                    </veui-grid-column>
                </veui-grid-row>
                <veui-grid-row v-for="({label, value}, index) in infoList" :key="value + index">
                    <veui-grid-column :span="6">
                        {{ label }}
                    </veui-grid-column>
                    <veui-grid-column v-if="label !== '身份证'" :span="18">
                        {{ confirmFormData[value] }}
                    </veui-grid-column>
                    <veui-grid-column v-else :span="18">
                        <img
                            class="img-show"
                            :src="confirmFormData.id_card_head_image_url"
                            alt=""
                        />
                        <img
                            class="img-show"
                            :src="confirmFormData.id_card_national_image_url"
                            alt=""
                        />
                    </veui-grid-column>
                </veui-grid-row>
            </veui-grid-container>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file law-profit.vue
 * @author sunxiaofeng01
 * @desc 收益设置
 */
import {
    GridContainer,
    GridRow,
    GridColumn,
    Button,
    Form,
    Field,
    Input,
    Uploader,
    Fieldset,
    DatePicker,
    Radio,
    Textarea,
    Checkbox,
    Dialog
} from 'veui';
import bendSDK from '@baidu/bend-plugin-sdk';
import isBoolean from 'lodash/isBoolean';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';
const url = {
    accountInfo: 'law:/themis/law/account/info',
    accountSave: 'law:/themis/law/account/save'
};

export default {
    name: 'profitSetting',
    components: {
        'veui-button': Button,
        'veui-field': Field,
        'veui-form': Form,
        'veui-input': Input,
        'veui-uploader': Uploader,
        'veui-fieldset': Fieldset,
        'veui-date-picker': DatePicker,
        'veui-radio': Radio,
        'veui-textarea': Textarea,
        'veui-checkbox': Checkbox,
        'veui-dialog': Dialog,
        'veui-grid-container': GridContainer,
        'veui-grid-row': GridRow,
        'veui-grid-column': GridColumn
    },
    data() {
        return {
            sexList: [
                {value: '男', label: '男'},
                {value: '女', label: '女'}
            ],
            buttonLoading: false,
            proviceData: [],
            cityData: [],
            subbranchData: [],
            formData: {
                id: '',
                username: null,
                card_num: null,
                id_card_num: null,
                phone_num: null,
                country: '中国',
                profession: 4,
                professionShow: '商业、服务业人员',
                address: null,
                sex: '男',
                id_card_expire_time: null,
                id_card_head_image_url: null,
                id_card_head_image_code: null,
                id_card_national_image_url: null,
                id_card_national_image_code: null,
                isAgree: null
            },
            rules: {
                accountCode: [
                    {
                        name: 'required',
                        value: true,
                        triggers: 'change',
                        message: '请输入银行账号'
                    },
                    {
                        name: 'maxLength',
                        value: 19,
                        triggers: 'change',
                        message: '已超出银行账号位数限制'
                    }
                ],
                mobileNumber: [
                    {
                        name: 'required',
                        value: true,
                        triggers: 'change',
                        message: '请输入银行预留手机'
                    },
                    {
                        name: 'maxLength',
                        value: 11,
                        triggers: 'change',
                        message: '已超出手机号位数限制'
                    }
                ],
                idCardNum: [
                    {
                        name: 'required',
                        value: true,
                        triggers: 'change',
                        message: '请输入身份证号'
                    },
                    {
                        name: 'maxLength',
                        value: 18,
                        triggers: 'change',
                        message: '已超出身份证号位数限制'
                    }
                ]
            },
            validators: [
                {
                    fields: ['phone_num'],
                    validate(phone_num) {
                        return new Promise(function (resolve) {
                            if (phone_num) {
                                setTimeout(function () {
                                    let res;
                                    let isPhone = (/^1[3456789]\d{9}$/.test(phone_num))
                                        || (/^[1][3-9]{2}(\*\*\*\*)[0-9]{4}$/.test(phone_num));

                                    if (!isPhone) {
                                        res = {
                                            phone_num: '请输入正确的手机号'
                                        };
                                    }
                                    return resolve(res);
                                });
                            }
                        });
                    }
                }
            ],
            inputDisabled: false,
            confirmModal: false,
            confirmFormData: {},
            infoList: [
                {label: '收款人姓名', value: 'username'},
                {label: '身份证', value: 'id_card_head_image_url'},
                {label: '身份证号', value: 'id_card_num'},
                {label: '银行账号', value: 'card_num'},
                {label: '银行预留手机号', value: 'phone_num'},
                {label: '身份证到期日', value: 'id_card_expire_time'},
                {label: '性别', value: 'sex'},
                {label: '国籍', value: 'country'},
                {label: '职业', value: 'professionShow'},
                {label: '现居住地址', value: 'address'}
            ]
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        uploaderChange(res, key) {
            this.formData[key] = res ? res.src : '';
        },
        convertResponse(resp, key) {
            const data = this.$normalizeResponseData(resp);
            let isSuccess = true;
            let src = true;
            let message = '上传成功';
            if (data) {
                const ocrInfo = data.ocrInfo;
                if (key === 'id_card_head_image') {
                    if (ocrInfo.card_type !== 'idcard_front' || Array.isArray(data) && !data.length) {
                        isSuccess = false;
                        src = '';
                        message = '请上传人像面';
                    }
                    else {
                        this.formData.address = ocrInfo.address;
                        this.formData.id_card_num = ocrInfo.id_card_no;
                        this.formData.username = ocrInfo.name;
                        this.formData.sex = ocrInfo.sex;
                    }
                }
                else {
                    if (ocrInfo.card_type !== 'idcard_back' || Array.isArray(data) && !data.length) {
                        isSuccess = false;
                        src = '';
                        message = '请上传国徽面';
                    }
                    else {
                        this.setExpireTime(ocrInfo.expire_date);
                    }
                }
                if (isSuccess) {
                    src = data.imageURL;
                    this.formData[key + '_code'] = data.signCode;
                    this.formData[key + '_url'] = data.imageURL;
                }
            }
            else {
                isSuccess = false;
                src = '';
                message = resp.msg;
            }
            return ({
                success: isSuccess,
                src,
                message
            });
        },
        getData() {
            this.$http.get(url.accountInfo, {}).then(resp => {
                const data = this.$normalizeResponseData(resp);
                if (data) {
                    this.inputDisabled = !data.can_modifi;
                    if (data.id_card_expire_time) {
                        this.setExpireTime(data.id_card_expire_time);
                    }
                    data.sex = data.sex || '男';
                    this.formData = Object.assign(this.formData, data);
                }
            }).catch(err => this.$normalizeResponseError(err));
        },
        setExpireTime(time = null) {
            if (time === '长期') {
                time = '99991231';
            }
            if (time.length === 8 && Number(time) > 0) {
                const fmtDate = new Date(time.replace(/(\d{4})(\d{2})(\d{2})/g, '$1/$2/$3'));
                this.formData.id_card_expire_time = (fmtDate.toString()) !== 'Invalid Date' ? fmtDate : null;
            }
            return time;
        },
        save() {
            this.$refs.profitForm.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.confirmModal = true;
                    this.confirmFormData = cloneDeep(this.formData);
                    const timeShow = dayjs(this.confirmFormData.id_card_expire_time).format('YYYY/MM/DD');
                    this.confirmFormData.id_card_expire_time = timeShow;
                }
                else {
                    const toast = {
                        content: '请完成必填选项',
                        duration: 3
                    };
                    this.$Message.info(toast);
                }
            });

        },
        postData() {
            this.buttonLoading = true;
            const tempData = cloneDeep(this.formData);

            tempData.card_num = tempData.card_num.replace(/\s*/g, '');
            const idExpireTime = dayjs(tempData.id_card_expire_time).format('YYYY/MM/DD').replace(/\//g, '');
            tempData.id_card_expire_time = idExpireTime;
            tempData.username = tempData.username || tempData.name;
            this.$http.post(url.accountSave, {
                ...tempData,
                params: JSON.stringify(tempData)
            }).then(resp => {
                const data = this.$normalizeResponseData(resp);
                if (data) {
                    const message = data.is_success ? 'success' : 'info';
                    this.$Message[message]({
                        content: data.is_success ? '保存成功' : data.info,
                        duration: 3
                    });
                    if (data.is_success) {
                        this.getData();
                    }
                }
            }).catch(err => this.$normalizeResponseError(err))
                .finally(() => this.buttonLoading = false);
        },
        getUrl(params) {
            const url = '/bp/api/upload?'
                + 'params=' + JSON.stringify(params);
            return url;
        },
        getCardUrl(paramsUrl) {
            const url = '/bp/api/uploadcard?' + paramsUrl;
            return url;
        },
        handleModal(type) {
            if (type === 'ok') {
                this.postData();
            }
        },

        /**
         * 返回收益中心
         */

        goBack() {
            this.$emit('hideBindCard');
        }
    }
};
</script>
<style lang="stylus" scoped>
@import '../../../assets/css/law-table.styl';
.profit-setting
    margin-right 20px

    .profit-setting-content
        background #fff
        padding-top 30px
        border-radius 4px
        .profit-setting-content-tip
            padding 22px 24px
            line-height 26px
            border-radius 4px
            font-size 16px
            color #333333
            background #FFF8F0
        .tip-email
            color #0067FF
        .profit-setting-form-title
            font-family: PingFangSC-Semibold;
            font-size 20px
            margin 24px 0
            color #000
        .profit-setting-form-show
            /deep/.veui-field
                margin-bottom 38px
        /deep/ .veui-field
            margin-bottom 24px
            &.s
                min-height 20px
                height 20px
            .veui-field-label
                width 8em
                color #000
            .veui-field-content
                color #282C33
        /deep/ .veui-date-picker
            width 300px
        /deep/ .veui-textarea
            width 300px
            height 78px
            background #fff
            border-radius 4px
            padding 2px
        /deep/ .veui-button[ui~="basic"]
            border-color #d3d9e6
            border-radius 3px
        .veui-invalid
            /deep/ .veui-button[ui~="basic"]
                border-color #cc1800
        .profit-setting-radio
            margin-right 24px

        .portrait  /deep/ .veui-uploader-input-label-image svg
            background url('../../../assets/img/law/card-portrait.png')
            color transparent
            background-size 100% 100%
        .emblem
            margin-left 12px
            /deep/ .veui-uploader-input-label-image svg
                background url('../../../assets/img/law/card-emblem.png')
                color transparent
                background-size 100% 100%
        .profit-setting-username
            margin-bottom 38px
    .profit-setting-footer
        background #fff
        padding 0 24px 24px 24px
        border-radius 4px
        text-align: center;
        /deep/ .veui-field-no-label
            margin-left 0
            margin-bottom 16px
        .ml12
            margin-left 12px

        .submit
            width 90px
            height 40px
            background #404EFF
    .desc-warp
        /deep/ .veui-field-content
            flex-wrap wrap
            width 100%
            flex 1 0
            .veui-input
                border-radius 3px
    .desc-warp-content
        width 600px
        font-size 12px
        color #999
        margin-left calc(12em)
        margin-bottom 24px
    .decs
        width 380px
        color #848B99
        height 100%
        margin-left 12px
        .pa12
            padding-left 12px
        .decs-active
            font-weight 600
    .img-wrapper
        min-height 120px
        display flex
        align-items center
        margin-right 12px
        border: 1px solid #E2E6F0;
        border-radius: 4px;
        float left
        .viewimg
            border 1px solid rgb(236, 236, 236)
            box-sizing border-box
            width 120px
    .veui-field-show
        /deep/ .veui-field-required .veui-field-label:before
            content: ''
        /deep/ .veui-field, .desc-warp-content
            margin-bottom 6px
    .profit-setting-rule
        margin-bottom 30px
        .file-name
            color #404EFF
.profit-setting-confirm-modal
    /deep/ .veui-grid-container
        padding: 0;
    /deep/ .veui-grid-row
        margin-bottom 14px
    .confirm-modal-tip
        margin-bottom 22px
    .img-show
        border 1px solid rgb(236, 236, 236)
        box-sizing border-box
        width 120px

.title-box
        display flex
        align-items center
        font-family PingFangSC-Regular
        font-size 16px
        color #333
        .back
            position relative
            padding-left 12px
            cursor pointer
            &::before
                content ''
                position absolute
                height 12px
                width 10px
                left 0
                top 50%
                transform translateY(-50%)
                background url(https://lvlin-base.cdn.bcebos.com/bend/back-icon.png) no-repeat center center / 100% 100%
        .line
            width 1px
            height 10px
            background #9d9d9d
            margin 0 12px
</style>
